import styled from "styled-components";

const ListingPageWrapper = styled.main`
  min-height: 100%;

  width: 100%;

  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export default ListingPageWrapper;
